module.exports = __webpack_public_path__ + "static/signature-multi-white-2c2041b836444d0792a993a68a088d56.svg";